import React from "react";
import Package from "./../../assets/img/packaging.jpg";
const SeedProcessing = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Seed Processing</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <div className="row mb-1 justify-content-between">
              <div className="col-lg-8 ">
                <p>
                  The empty gunny bags are issued by the Regional units to the
                  growers on the basis of final inspection report and estimated
                  production given by Packaging Haryana State Seed Certification
                  Agency staff for bringing their raw seed. Utmost care is taken
                  up by the technical staff of the Corporation at the time of
                  intake of raw seed at processing plants and different checks
                  to ascertain the quality of seed are carried out{" "}
                </p>
              </div>
              <div className="col-lg-4  text-center">
                <img
                  src={Package}
                  alt="Seed Production"
                  className="img-fluid rounded shadow-sm"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 mb-1">
            <p>
              i.e checking of moisture contents, variety wise unloading and
              storage of raw seed and finally allocating identification marks on
              every raw seed bags - indicating different varieties belonging to
              different growers. Quality Control standards and parameters are
              maintained at the time of processing.
            </p>
            <p>
              The Corporation is having six processing plants located at Umri,
              Yamuna Nagar, Hisar, Sirsa, Tohana & Pataudi. Further, Air
              Pollution Control System has also been installed at the Six units
              to minimize the Air Pollution and to provide free Atmosphere to
              the employees working at Seed Processing Plant. The total
              installed seasonally Processing capacity of the six plants and
              their storage capacity are as under:
            </p>
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <th id="plant" rowspan="2" scope="col">
                      Sr. No.
                    </th>
                    <th id="plant1" rowspan="2" scope="col">
                      Name of the Plant
                    </th>
                    <th colspan="2" id="plant2" scope="col">
                      (in qtls.)
                    </th>
                  </tr>
                  <tr>
                    <th>Processing Capacity per Hour</th>
                    <th>Storage Capacity</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>
                      Umri
                      <br />
                      (Distt. Kurukshetra)
                    </td>
                    <td>100.00</td>
                    <td>110000</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Yamuna Nagar</td>
                    <td>50.00</td>
                    <td>45000</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Hisar</td>
                    <td>100.00</td>
                    <td>88000</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Sirsa</td>
                    <td>100.00</td>
                    <td>84500</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>
                      Tohana
                      <br />
                      (Distt. Fatehabad)
                    </td>
                    <td>50.00</td>
                    <td>54000</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>
                      Pataudi
                      <br />
                      (Distt. Gurgaon)
                    </td>
                    <td>90.00</td>
                    <td>67500</td>
                  </tr>
                  <tr>
                    <td className="bold">&nbsp;</td>
                    <td className="bold">Total</td>
                    <td className="bold">490.00</td>
                    <td className="bold">4,49,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeedProcessing;
